import { ConsultaSeguimentoArrowDown } from '@mchat-rf/consulta-seguimento/components/ConsultaSeguimentoArrowDown'
import { ConsultaSeguimentoIndicatorHelper } from '@mchat-rf/consulta-seguimento/components/ConsultaSeguimentoIndicatorHelper'
import { ConsultaSeguimentoIndicatorResultado } from '@mchat-rf/consulta-seguimento/components/ConsultaSeguimentoIndicatorResultado'
import { ConsultaSeguimentoIndicatorStart } from '@mchat-rf/consulta-seguimento/components/ConsultaSeguimentoIndicatorStart'
import { ConsultaSeguimentoPerguntaHeader } from '@mchat-rf/consulta-seguimento/components/ConsultaSeguimentoPerguntaHeader'
import { ConsultaSeguimentoPerguntaHeaderTitle } from '@mchat-rf/consulta-seguimento/components/ConsultaSeguimentoPerguntaHeaderTitle'
import { PerguntaSimNaoRadioGroupBoxField } from '@mchat-rf/consulta-seguimento/components/PerguntaSimNaoRadioGroupBoxField'
import { PerguntaSimNaoRadioListField } from '@mchat-rf/consulta-seguimento/components/PerguntaSimNaoRadioListField'
import { isPerguntaStatusRespondendo } from '@mchat-rf/consulta-seguimento/consulta-seguimento-aplicacao/utils-consultaSeguimentoAplicacao'
import { PodeNaoPodeEnum } from '@mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { useConsultaSeguimentoAutoScroll } from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoAutoScroll'
import { useConsultaSeguimentoSetResultado } from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoSetResultado'
import { Flow, VFlow } from 'bold-ui'
import { RadioOption, resolveName, SimNaoEnum } from 'components/form'
import { RadioGroupBoxField } from 'components/form/field/RadioGroupBoxField'
import { SimNaoSwitchButtonField } from 'components/form/field/SimNaoSwitchButtonField'
import { MChatPerguntaEnum } from 'graphql/types.generated'
import { RefObject } from 'react'
import { useField } from 'react-final-form'
import { isEmpty } from 'util/checks'
import { MetaPath } from 'util/metaPath'

import {
  ConsultaSeguimentoPergunta18ExemplosEnum,
  ConsultaSeguimentoPergunta18Model,
} from './model-consultaSeguimentoPergunta18'
import { PERGUNTA_18_SCROLL_CONFIG } from './scrollConfig-consultaSeguimentoPergunta18'
import { calculateResultadoPergunta18, conditionToCalculatePergunta18 } from './utils-consultaSeguimentoPergunta18'

interface ConsultaSeguimentoPergunta18FieldProps {
  name: MetaPath<ConsultaSeguimentoPergunta18Model>
  containerRef: RefObject<HTMLDivElement>
  goNextButtonRef: RefObject<HTMLButtonElement>
}

export function ConsultaSeguimentoPergunta18Field(props: Readonly<ConsultaSeguimentoPergunta18FieldProps>) {
  const { name, containerRef, goNextButtonRef } = props

  const {
    input: { value },
  } = useField<ConsultaSeguimentoPergunta18Model>(resolveName(name), {
    subscription: { value: true },
  })

  useConsultaSeguimentoSetResultado<ConsultaSeguimentoPergunta18Model>({
    name,
    conditionToCalculate: conditionToCalculatePergunta18,
    calculateResultado: calculateResultadoPergunta18,
  })

  const { getId, triggerScrollFor } = useConsultaSeguimentoAutoScroll<ConsultaSeguimentoPergunta18Model>({
    name,
    containerRef,
    goNextButtonRef,
    scrollConfig: PERGUNTA_18_SCROLL_CONFIG,
  })

  return (
    <VFlow vSpacing={0}>
      <VFlow>
        {isPerguntaStatusRespondendo(value.status) && (
          <ConsultaSeguimentoPerguntaHeader
            pergunta={MChatPerguntaEnum.PERGUNTA_18}
            title={
              <ConsultaSeguimentoPerguntaHeaderTitle sufix=' compreende quando você diz a ele para fazer alguma coisa?' />
            }
            status={value.status}
            field={
              <SimNaoSwitchButtonField
                name={name.PERGUNTA_18_HEADER}
                onChange={() => triggerScrollFor('PERGUNTA_18_HEADER')}
              />
            }
          />
        )}
        <VFlow vSpacing={0}>
          {!isEmpty(value?.PERGUNTA_18_HEADER) && <ConsultaSeguimentoIndicatorStart />}

          {value?.PERGUNTA_18_HEADER === SimNaoEnum.SIM && (
            <VFlow vSpacing={0.5} id={getId('PERGUNTA_18_PODE_NAO_PODE')}>
              <ConsultaSeguimentoIndicatorHelper title='Por favor, dê um exemplo de como ele compreendeu você.' />
              <RadioGroupBoxField
                name={name.PERGUNTA_18_PODE_NAO_PODE}
                label='O exemplo indica que:'
                options={PERGUNTA_18_PODE_NAO_PODE_OPTIONS}
                required
                onChange={() => triggerScrollFor('PERGUNTA_18_PODE_NAO_PODE')}
              />
            </VFlow>
          )}

          {(value?.PERGUNTA_18_HEADER === SimNaoEnum.NAO ||
            value.PERGUNTA_18_PODE_NAO_PODE === PodeNaoPodeEnum.NAO_PODE) && (
            <Flow direction='vertical' gap={0}>
              {value?.PERGUNTA_18_HEADER === SimNaoEnum.SIM &&
                value?.PERGUNTA_18_PODE_NAO_PODE === PodeNaoPodeEnum.NAO_PODE && <ConsultaSeguimentoArrowDown />}
              <div id={getId('PERGUNTA_18_TEM_DICA_SEGUE_ORDEM')}>
                <PerguntaSimNaoRadioGroupBoxField
                  name={name.PERGUNTA_18_TEM_DICA_SEGUE_ORDEM}
                  label={
                    <>
                      Quando ele/ela tem uma dica, ele consegue seguir a ordem? <br />
                      Por exemplo, quando você está vestido para sair e diz a ele para pegar o seu sapato, ele entende?
                    </>
                  }
                  required
                  onChange={() => triggerScrollFor('PERGUNTA_18_TEM_DICA_SEGUE_ORDEM')}
                />
              </div>
              {value?.PERGUNTA_18_TEM_DICA_SEGUE_ORDEM === SimNaoEnum.NAO && (
                <Flow direction='vertical' gap={0} id={getId('PERGUNTA_18_SENTA_A_MESA')}>
                  <ConsultaSeguimentoArrowDown />
                  <PerguntaSimNaoRadioGroupBoxField
                    name={name.PERGUNTA_18_SENTA_A_MESA}
                    label='Se é hora do jantar e a comida está na mesa, e você diz ao seu filho para se sentar, ele se senta à mesa?'
                    required
                    onChange={() => triggerScrollFor('PERGUNTA_18_SENTA_A_MESA')}
                  />
                </Flow>
              )}
              {(value?.PERGUNTA_18_TEM_DICA_SEGUE_ORDEM === SimNaoEnum.SIM ||
                value?.PERGUNTA_18_SENTA_A_MESA === SimNaoEnum.SIM) && (
                <Flow direction='vertical' id={getId('PERGUNTA_18_EXEMPLOS')}>
                  <ConsultaSeguimentoArrowDown />
                  <PerguntaSimNaoRadioListField<ConsultaSeguimentoPergunta18ExemplosEnum>
                    name={name.PERGUNTA_18_EXEMPLOS}
                    label={
                      <>
                        Quando a situação não dá nenhuma dica, ele consegue seguir uma ordem? <br />
                        Por exemplo...
                      </>
                    }
                    description='Pergunte até obter um sim ou use todos os exemplos:'
                    required
                    options={PERGUNTA_18_EXEMPLOS_OPTIONS}
                    onChange={() => triggerScrollFor('PERGUNTA_18_EXEMPLOS')}
                  />
                </Flow>
              )}
            </Flow>
          )}
        </VFlow>
      </VFlow>
      {value?.resultado && (
        <ConsultaSeguimentoIndicatorResultado
          text={{
            FALHOU:
              value?.PERGUNTA_18_TEM_DICA_SEGUE_ORDEM === SimNaoEnum.NAO &&
              value?.PERGUNTA_18_SENTA_A_MESA === SimNaoEnum.NAO
                ? ''
                : 'Não para todas:',
            PASSOU:
              value?.PERGUNTA_18_HEADER === SimNaoEnum.SIM && value?.PERGUNTA_18_PODE_NAO_PODE === PodeNaoPodeEnum.PODE
                ? ''
                : 'Sim para qualquer uma:',
          }}
          resultado={value.resultado}
        />
      )}
    </VFlow>
  )
}

const PERGUNTA_18_PODE_NAO_PODE_OPTIONS: RadioOption<PodeNaoPodeEnum>[] = [
  {
    label: (
      <>
        A criança <strong>pode</strong> compreender uma ordem simples, sem sinais não-verbais.
      </>
    ),
    value: PodeNaoPodeEnum.PODE,
  },
  {
    label: (
      <>
        A criança <strong>não pode</strong> compreender uma ordem simples, sem sinais não-verbais.
      </>
    ),
    value: PodeNaoPodeEnum.NAO_PODE,
  },
]

const PERGUNTA_18_EXEMPLOS_OPTIONS: RadioOption<ConsultaSeguimentoPergunta18ExemplosEnum>[] = [
  {
    label:
      'Se você diz: “Me mostre o seu sapato” sem apontar, fazendo gestos, ou dando sugestões (quando você não está saindo ou se vestindo), o seu filho mostra o sapato?',
    value: ConsultaSeguimentoPergunta18ExemplosEnum.SEM_DICA_MOSTRA_SAPATO,
  },
  {
    label:
      'Se você diz: “Me traz o cobertor” ou pede outro objeto sem apontar, sem fazer gestos, ou sem dar sugestões, o seu filho traz para você?',
    value: ConsultaSeguimentoPergunta18ExemplosEnum.SEM_DICA_TRAZ_COBERTOR,
  },
  {
    label:
      'Se você diz: “Põe o livro na cadeira” sem apontar, sem fazer gestos, ou sem dar quaisquer outras sugestões, o seu filho coloca o livro na cadeira?',
    value: ConsultaSeguimentoPergunta18ExemplosEnum.SEM_DICA_POE_LIVRO_CADEIRA,
  },
]
